import { ymReachGoal } from "../utils/ym";
export var getOnScreenAnalyticsHandler = function getOnScreenAnalyticsHandler(payment_method) {
  return function (props) {
    ymReachGoal('FinPaymentCardpayment', {
      currency: 'RUB',
      order_price: props.sum,
      payment_method: payment_method
    });
  };
};